/* eslint-disable camelcase */

export const EdgeDeviceTypes = {
  UNDEFINED: "undefined",
  SGC200: "sgc200",
  SGC500_AA: "sgc500_powerbox",
  SGC500_AB: "sgc500_karbon_300",
  SGC500_AB_24: "sgc500_karbon_300_c24",
  SGC500_AC: "sgc500_vl3_upc_1320",
  SGC500_SW: "sgc500_sw",
};
